import { PropsWithChildren } from "react";
import { useTranslations } from "../../hooks/useTranslations";
import { OpenItemStatus } from "../../types";
import SearchBar from "../ui/SearchBar";
import styles from "./Filters.module.css";

type StatusFilterOption = OpenItemStatus | "all";

export interface FilterState {
  status: StatusFilterOption;
  openUntil: number | undefined;
  term: string;
}

interface Props {
  state: FilterState;
  years: number[];
  onChange: (updated: FilterState) => void;
}

const Filters = ({ state, years, onChange }: Props) => {
  const { i18n } = useTranslations();
  return (
    <div className={styles.filters}>
      <Filter id="status" label={i18n.openItems.filters.status.label}>
        <select
          id="status"
          defaultValue={state.status}
          onChange={(e) =>
            onChange({
              ...state,
              status: e.target.value as StatusFilterOption,
            })
          }
        >
          <option value="all">
            {i18n.openItems.filters.status.option.all}
          </option>
          <option value="open">
            {i18n.openItems.filters.status.option.open}
          </option>
          <option value="settled">
            {i18n.openItems.filters.status.option.settled}
          </option>
        </select>
      </Filter>

      <Filter id="openUntil" label={i18n.openItems.filters.openUntil}>
        <select
          id="openUntil"
          defaultValue={state.openUntil}
          onChange={(e) =>
            onChange({
              ...state,
              openUntil: +e.target.value,
            })
          }
        >
          {years
            .sort((a, b) => b - a)
            .map((year, index) => (
              <option key={index} value={year}>
                {year}
              </option>
            ))}
        </select>
      </Filter>

      <Filter id="search" label={i18n.openItems.filters.search.label}>
        <SearchBar
          id="search"
          className={styles.search}
          placeholder={i18n.openItems.filters.search.placeholder}
          value={state.term}
          onChange={(term) =>
            onChange({
              ...state,
              term,
            })
          }
        />
      </Filter>
    </div>
  );
};

type FilterProps = PropsWithChildren<{ id: string; label: string }>;

const Filter = ({ id, label, children }: FilterProps) => (
  <div className={styles.filter}>
    <label htmlFor={id}>{label}</label>
    {children}
  </div>
);

export default Filters;
